<script>
import loginForm from "@/components/loginForm";
export default {
  name: "login",
  components: {
    loginForm,
  },
  data: function() {
    return {};
  },
  methods: {},
  computed: {},
  mounted: function() {},
};
</script>

<template>
  <v-row align="center" justify="center">
    <v-col>
      <login-form></login-form>
    </v-col>
  </v-row>
</template>

<style scoped></style>
